import type { Components, Theme } from "@mui/material";

export const paperTheme: Components<Theme>["MuiPaper"] = {
  defaultProps: {
    elevation: 0,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.main,
    }),
  },
};
